<template>
  <LegalAndPrivacyLayout
      titleKVP="hbs_flow_title"
      headingLocalizerKey="privacy_policy_header"
      :policyType="policyType"
      scrollable
      back-icon-list="fa-solid fa-house-circle-xmark"
      class-list="canary setup terms"
      :onBackClick="onAbandonClick"
    :showTitle="true">

    <template v-slot:auxiliary>
      <zbm-btn-icon @click="onInfoClick()" icon="fa-regular fa-question-circle" size="24px" text-color="dark-teal"
                    data-testid="backArrow"/>
    </template>

    <template v-slot:actions>
      <div class="row" style="margin-top: 48px">
        <div class="col">
          <!-- Checkbox -->
          <zbm-checkbox v-model="checked" id="userPolicyCheck" name="userPolicyCheck">
            {{ t('canary_privacy_policy') }}
          </zbm-checkbox>
        </div>
      </div>

      <div class="col canary-continue">
        <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accent"
                 :label="t('acc_gen_continue')"
                 :outline="true"
                 :disabled="!checked"
                 :width="$zb.enums.ButtonWidthEnum.wFull"
                 :height="$zb.enums.ButtonHeightEnum.lg"
                 @click="onNextClick"/>
      </div>
    </template>
  </LegalAndPrivacyLayout>

  <the-abandon-modal v-model="showAbandon"/>
  <the-contact-modal v-model="showContact"/>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { useQuasar } from 'quasar';

import LegalAndPrivacyLayout from '@/components/layouts/LegalAndPrivacyLayout.vue';
import TheContactModal from '@/components/TheContactModal.vue';
import TheAbandonModal from '@/components/TheAbandonModal.vue';

import { handleApiRequest } from '@/api/handleApiRequest';
import { updatePolicy } from '@/api/endpoints/registrationWeb';

import { createDecisionModal } from '@/utils/generalPurposeModalFactory';

import { useGeneralPurposeModalStore } from '@/store';

import { UserPolicyType } from '@/constants/enums';

import { getNextActivationRoute } from '@/services/piqSetupService';

const $q = useQuasar()
const generalPurposeModalStore = useGeneralPurposeModalStore()
const router = useRouter();
const {t} = useI18n();

const policyType = ref<UserPolicyType>(UserPolicyType.CanaryPiqPrivacyPolicy);
const checked = ref(false);
const showAbandon = ref(false);
const showContact = ref(false);

async function onNextClick() {
  if (checked.value) {
    $q.loading.show();
    const response = await handleApiRequest(() => updatePolicy(policyType.value, false, true), null, $q
    ).finally(() => {
      $q.loading.hide();
    });

    if (!response?.result) {
      // error
    } else {
      var nextRoute = await getNextActivationRoute($q);
      router.push({ name: nextRoute }).catch(() => { });
    }

  } else {
    const info = createDecisionModal('', t('piq_t_c_error'));
    generalPurposeModalStore.setModal(info);
  }
}

async function onAbandonClick() {
  showAbandon.value = !showAbandon.value;
}

async function onInfoClick() {
  showContact.value = !showContact.value;
}
</script>
